import { FC, useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import { ProfileMemberBadges } from './ProfileMemberBadges'
import { ProfileMemberLanguages } from './ProfileMemberLanguages'
import { ProfileMemberIntroductions } from './ProfileMemberIntroductions'
import { ProfileMemberSocials } from './ProfileMemberSocials'
import { Form, Formik } from 'formik'
import { getMemberConfigNotification, updateMemberConfigNotification } from '../../../services/membersAdminService'
import * as Yup from 'yup'
import { showErrorAlert } from '../../../helpers/alert'
import { updateProfile } from '../../../services/profileAdminService'
import { useUserProfileContext } from '../../../context/UserProfileContext'
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction'

interface ProfileMemberInfoProps {
  userId: number
  user: string
  expertise: any[]
  firstName: string
  surname: string
  aliasTitle: string
  bioPresentation: string
  city: string
  languages: string[]
  introduction: any[]
  socialMediaProfiles: any[]
  subscription: any
  isFoundingMember?: boolean
}

type Assignment = { id: number; userActive: boolean }

export const ProfileMemberInfo: FC<ProfileMemberInfoProps> = ({
  userId,
  user,
  expertise,
  firstName,
  surname,
  aliasTitle,
  bioPresentation,
  city,
  languages,
  introduction,
  socialMediaProfiles,
  subscription,
  isFoundingMember,
}) => {
  // const hasExpertise = expertise.length > 0;
  const [configFoundingMember, setConfigFoundingMember] = useState<boolean>(isFoundingMember)
  const [configs, setConfigs] = useState<any[]>([])
  const [initialValues, setInitialValues] = useState({
    user_id: userId,
    notification_ids: [],
    active: true
  })
  const confirm = useConfirmAction()
  const { refetch } = useUserProfileContext()

  const validationSchema = Yup.object({
    notification_ids: Yup.array().of(
      Yup.object({
        id: Yup.number().required('Id is required'),
        userActive: Yup.boolean(),
      }),
    ),
  });

  useEffect(() => {
    getConfigNotificacions();
  }, [])

  const getConfigNotificacions = async () => {
    let configs_ = await getMemberConfigNotification({ user_id: userId })
    setConfigs(configs_)
    setInitialValues({
      user_id: userId,
      notification_ids: configs_,
      active: true
    })
  }

  const handleAssignmentToggle = (index: number,notifications: Assignment[],setFieldValue: (field: string, value: any) => void) => {
    setFieldValue(
      `notification_ids[${index}].userActive`,
      !notifications[index].userActive
    )
  }

  const handleSubmit = async (values) => {
    let params = { ...values };
    params.notification_ids = (params.notification_ids ?? []).map((item)=>{return {id: item.id, is_configured: item.userActive}})
    let resp = await updateMemberConfigNotification(params);
    if (resp.status == 200) {
      showErrorAlert({ title: 'Success', message: 'Updated successfully.' });
      setConfigs(resp.data)
      setInitialValues({
        user_id: userId,
        notification_ids: resp.data,
        active: true
      })
    }
  }

  const handleTag = async (e) => {
    let isChecked = e?.target?.checked;
    console.log('checked',isChecked)
    let isConfirm = await confirm({title:'Confirm Action',message:`Are you sure you want to ${isChecked ? 'assign' : 'remove'} the Founding Member tag to this member?`})
    if(isConfirm){
      setConfigFoundingMember(isChecked)
      let response = await updateProfile({is_founding_member:isChecked},userId)
      console.log('response',response)
      if(response.hasOwnProperty('isFoundingMember')){
        showErrorAlert({title: 'Tag Updated',message: 'The member tag has been updated successfully.'})
      }else{
        showErrorAlert({title: 'Update Failed',message: 'The member tag could not be updated. Please try again later.'})
      }
      refetch()
    }
  }

  return userId && (
    <div className='nb-pm-info'>
      {/* <div className='nb-pm-info__id'>#{user}</div> */}

      <div className='nb-pm-info__info-section'>
        <ProfileMemberBadges hasExpertise={false} subscription={subscription} isFoundingMember={isFoundingMember} />

        <div className='nb-pm-profile'>
          <div className='nb-pm-name-wrapper'>
            <div className='nb-pm-name'>{`${aliasTitle ? aliasTitle : ''} ${firstName} ${surname}`}</div>
          </div>
          <div className='biography__divider'></div>
          <div className='nb-pm-description'>{bioPresentation}</div>

          {city && (
            <div className='nb-pm-location'>
              <KTSVG path='/media/svg/nobilis/location_mark.svg' />
              <span className='nb-pm-location-text'>{city}</span>
            </div>
          )}
        </div>
      </div>

      {languages && languages.length > 0 && <ProfileMemberLanguages languages={languages} />}

      {introduction && introduction.length > 0 && (
        <ProfileMemberIntroductions introduction={introduction} />
      )}

      {socialMediaProfiles && socialMediaProfiles.length > 0 && (
        <ProfileMemberSocials socialMediaProfiles={socialMediaProfiles} />
      )}
      <div className='w-100 gap-3'>
        <div className="assignment-title mb-4">Tags</div>
        <div className='pf-checkbox mb-2'>
          <input type="checkbox" id='is_member_founding_check' className="pf-check" checked={configFoundingMember}
            onChange={handleTag} />
          <label htmlFor='is_member_founding_check' className="pf-checkbox-content tap-flex-center">
            <div className="assignment-description mt-1">Is Member Founding</div>
          </label>
        </div>
      </div>

      {/* notificacion */}
      <div className='w-100 gap-3'>
        <div className="assignment-title mb-4">Mailing Configuration</div>
        <Formik initialValues={initialValues} validationSchema={validationSchema} enableReinitialize={true} onSubmit={handleSubmit}>
          {(formik) => {
            return (<Form className='d-flex flex-column gap-10'>
              <div className="w-100">
                {(configs ?? []).map((config: any, index: number) => {
                  return (<div className='pf-checkbox mb-2' key={`notification-config-${index}-key`}>
                    <input type="checkbox" id={`notification-config-${index}`} className="pf-check" checked={formik.values.notification_ids[index]?.userActive}
                      onChange={() => handleAssignmentToggle(index, formik.values.notification_ids, formik.setFieldValue)} />
                    <label htmlFor={`notification-config-${index}`} className="pf-checkbox-content tap-flex-center">
                      {/* <div className="assignment-title">{config?.name}</div> */}
                      <div className="assignment-description mt-1">{config?.description}</div>
                    </label>
                  </div>)
                })}
                <button type="submit" className="tap-add-experience-2-btn-main mt-6">
                  <div className="tap-host-button-text tap-flex-center">
                      Save Mailing Configuration
                      &nbsp;<KTSVG path="/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg" />
                  </div>
                </button>
                <div className="assignment-description mt-2">* Only the configuration will be saved. No activation email will be sent.</div>
              </div>
            </Form>)
          }}
        </Formik>
      </div>
    </div>
  )
}